import getProducts from "./getProducts";
import getStaffToken from "./getStaffToken";
import addDish from "./addDish";
import getHistoryOrder from "./getHistoryOrder";
import openTable from "./openTable";
import makePayment from "./makePayment";
import paymentRequest from "./paymentRequest.api";
import paymentQuery from "./paymentQuery.api";
import addPrepayDish from "./addPrepayDish.api";
import getHistoryOrderById from "./getHistoryOrderById.api";
import getWebSiteSettings from "./getWebSiteSettings.api";

export {
  addDish,
  openTable,
  makePayment,
  getProducts,
  paymentQuery,
  getStaffToken,
  paymentRequest,
  getHistoryOrder,
  addPrepayDish,
  getHistoryOrderById,
  getWebSiteSettings,
};
